import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

import { RunContext } from "components/Run/Context";
import useTypedContext from "hooks/useTypedContext";
import { ObservabilityProcessingStatus, Stack } from "types/generated";

import { getRunObservabilityFindings } from "./Findings/utils";
import { GET_RUN_OBSERVABILITY_DATA } from "./gql";

export const useRunObservabilityData = () => {
  const { run, stack } = useTypedContext(RunContext);

  const { data, loading, error } = useQuery<{ stack: Stack }>(GET_RUN_OBSERVABILITY_DATA, {
    variables: { stackId: stack.id, runId: run.id },
    skip: run.observabilityStatus?.metrics !== ObservabilityProcessingStatus.Available,
  });

  const workerMetrics = data?.stack?.run?.workerMetrics;

  const workerFindings = data?.stack?.run?.workerFindings;

  const findings = useMemo(
    () => getRunObservabilityFindings(workerFindings?.findings),
    [workerFindings]
  );

  return {
    workerMetrics,
    outcome: workerFindings?.outcome,
    findings,
    loading,
    error,
  };
};
